module.exports = __webpack_public_path__ + "static/media/Suited.ccb6e752.svg";